/*
 * @Description: 付款信息修改记录
 * @Author: 杨志航
 * @Date: 2026-04-01 09:13:33
 */

import React, { useState, useEffect, useRef } from 'react'
import api from 'api'
import {
  Table,
  Form,
  Input,
  Button,
  message,
  Switch,
  Select,
  Alert,
  Popconfirm,
} from 'antd'
import { parseSearch, allTrim, filterParams, cryptoParamsIntoUrl } from '@/utils'
import { Link } from 'react-router-dom'
import CorpFilter from '@/components/CorpFilter'

const { Column } = Table
const FormItem = Form.Item
const Option = Select.Option
const dateFormat = 'YYYY-MM-DD'
const statusList = ['pending', 'canceled', 'approved', 'rejected']

let pageSize = 10
let currentPage = 1
let searchParams = {
  limit: pageSize, 
  page: currentPage,
}

const PaymentLog = props => {
  const { getFieldDecorator, validateFields, resetFields, setFieldsValue, getFieldsValue } = props.form
  const { location } = props
  const search = parseSearch(location.search)
  const [count, setCount] = useState(0)
  const [list, setList] = useState([])
  const [loading, setLoading] = useState(false)
  const [shouldMe, setShouldMe] = useState(false)
  const [assetTypeList, setAssetTypeList] = useState([])
  const corpFilterRef = useRef(null)

  useEffect(() => {
    const { bizno } = search
    if (bizno) {
      setFieldsValue({
        bizno
      })
      searchParams.bizno = bizno
    }
    api.getVariousSelectionList().then(data => setAssetTypeList(data.types))
    resetParams()
    getList()
  }, [])

  const resetParams = () => {
    searchParams = {
      limit: pageSize, 
      page: currentPage,
    }
  }

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 18 },
    }
  }

  //获取列表
  const getList = () => {
    setLoading(true)
    api.getAssetPurchasePaymentLogList(searchParams).then(res => {
      const { list, count } = res
      setList(list)
      setCount(count)
      setLoading(false)
    }).catch(() => { setLoading(false) })
  }

  //重置
  const onReset = () => {
    corpFilterRef.current.reset()
    resetFields()
    setShouldMe(false)
    currentPage = 1
    resetParams()
    getList()
  }

  //提交
  const formSubmit = evt => {
    evt.preventDefault()
    setFieldsValue(allTrim(getFieldsValue()))
    validateFields((err, vals) => {
      if (!err) {
        vals = filterParams(vals)
        if (vals.joiningDate && vals.joiningDate.length === 2) {
          vals.joiningDateMin = vals.joiningDate[0].format(dateFormat)
          vals.joiningDateMax = vals.joiningDate[1].format(dateFormat)
        }
        delete vals.joiningDate
        const { shouldMe, companyId } = searchParams
        if (shouldMe) {
          vals.shouldMe = shouldMe
        }
        if (companyId) {
          vals.companyId = companyId
        }
        currentPage = 1
        resetParams()
        searchParams = {...searchParams, ...vals}
        getList()
      }
    })
  }
  //点击分页
  const onChangeTable = (pagination, filters, sorter) => {
    searchParams.page = currentPage = pagination.current
    searchParams.limit = pageSize = pagination.pageSize
    getList()
  }

  const handleAudit = (id, status) => {
    setLoading(true)
    api.auditAssetPurchasePayment({
      id,
      status
    }).then(() => {
      if (status === 3) {
        message.success('审核通过')
      } else {
        message.success('审核驳回')
      }
      getList()
    }).catch(() => { setLoading(false) })
  }

  const onSetShouldMe = checked => {
    setShouldMe(checked)
    if (checked) {
      searchParams.status = 1
    } else {
      delete searchParams.status
    }
    getList()
  }

  const handleCancel = id => {
    setLoading(true)
    api.cancelAssetPurchasePayment({
      id
    }).then(() => {
      message.success('取消成功')
      getList()
    }).catch(() => { setLoading(false) })
  }

  const onChangeCorp = data => {
    searchParams.page = currentPage = 1
    if (data[0]) {
      searchParams.companyId = data[0].id
    } else {
      delete searchParams.companyId
    }
    getList()
  }

  return <>
    <div className="search-doc-wrap">
      <CorpFilter onChange={onChangeCorp} ref={corpFilterRef} />
      <Form onSubmit={formSubmit} {...formItemLayout} style={{ paddingTop: '10px' }}>
        <div className="form-box">
          <FormItem label="订单编号">
            {getFieldDecorator('number')(<Input placeholder="请输入订单编号" />)}
          </FormItem>
          <FormItem label="业务编号">
            {getFieldDecorator('sId')(<Input placeholder="请输入业务编号" />)}
          </FormItem>
          <FormItem label="资产类别">
            {getFieldDecorator('assetType')(<Select 
              placeholder="请选择"
              allowClear
              showSearch
              optionFilterProp="children"
            >
              {
                assetTypeList.map((item, index) => <Option key={index} value={item.id}>{item.name}</Option>)
              }
            </Select>)}
          </FormItem>
          <FormItem label="修改人">
            {getFieldDecorator('userId')(<Input placeholder="请输入修改人" />)}
          </FormItem>
        </div>
        <FormItem className="btns" label=" " colon={false}>
          <Switch 
            checkedChildren="待确认" 
            unCheckedChildren="待确认" 
            disabled={loading} 
            onChange={onSetShouldMe} 
            className="shouldme-switch-btn" 
            checked={shouldMe}
          />
          <Button type="primary" htmlType="submit">查询</Button>
          <Button onClick={onReset}>重置</Button>
        </FormItem>
      </Form>
    </div>
    <div className="line"></div>
    <div>
      <Alert className="corp-count" message={`总计：${count}条数据`} type="info" showIcon />
      <Table
        size="small"
        dataSource={list}
        rowKey="id"  
        loading={loading}
        pagination={{
          pageSize,
          total: count,
          current: currentPage,
          showQuickJumper: true,
          showSizeChanger: true,
          pageSizeOptions: ['10', '50', '100', '500', '1000', '2000']
        }}
        onChange={onChangeTable}
        scroll={{ x: 'max-content' }}
      >
        <Column 
          title="订单编号" 
          dataIndex="number" 
          fixed="left"
        />
        <Column 
          title="业务编号" 
          dataIndex="sId" 
          render={(text, record) => <Link target="_blank" to={cryptoParamsIntoUrl('/asset/purchase/details', { id: record.sId })}>{text}</Link>}
        />
        <Column title="付款方式" dataIndex="payTypeName" />
        <Column title="公司主体" dataIndex="companyName" />     
        <Column title="资产类别" dataIndex="assetTypeName" />
        <Column title="付款金额" dataIndex="money" />
        <Column 
          title="变更前付款账号" 
          render={record => record.old.payAccountNo || '-'} 
        />
        <Column 
          title="变更前付款开户行" 
          render={record => record.old.payBank || '-'} 
        />
        <Column 
          title="变更后付款账号" 
          render={record => record.new.payAccountNo || '-'} 
        />
        <Column 
          title="变更后付款开户行" 
          render={record => record.new.payBank || '-'} 
        />
        <Column 
          title="变更前支付日期" 
          render={record => record.old.payTime || '-'} 

        />     
        <Column 
          title="变更后支付日期" 
          render={record => record.new.payTime || '-'} 
        />
        <Column 
          title="变更前付款凭证" 
          render={record => <a href={record.old.certificate && record.old.certificate[0]?.url} target='_blank'>{record.old.certificate && record.old.certificate[0]?.name}</a>} 
        />
        <Column 
          title="变更后付款凭证" 
          render={record => <a href={record.new.certificate && record.new.certificate[0]?.url} target='_blank'>{record.new.certificate && record.new.certificate[0]?.name}</a>} 
        />
        <Column title="修改人" dataIndex="userName" />
        <Column title="修改时间" dataIndex="addTime" />
        <Column 
          title="修改状态" 
          dataIndex="statusName"
          className="payment-log-status"
          render={(text, record) => <div className={statusList[record.status - 1]}>{text}</div>} 
        />
        <Column 
          title="操作"
          key="set" 
          align="center"
          width={100}
          fixed="right"
          render={(text, record) => (
            <>
              {record.canApproval && (
                <div>
                  <Popconfirm 
                    title="请确认是否通过?" 
                    onConfirm={() => handleAudit(record.id, 3)}
                  >
                    <a>确认</a>
                  </Popconfirm>
                  <Popconfirm 
                    title="请确认是否通过?" 
                    onConfirm={() => handleAudit(record.id, 4)}
                  >
                    <a style={{ marginLeft: '10px', color: '#f5222d' }}>驳回</a>
                  </Popconfirm>
                </div>
              )}
              {
                record.canCancel && (
                  <Popconfirm 
                    title="请确认是否取消?" 
                    onConfirm={() => handleCancel(record.id)}
                  >
                    <a>取消修改</a>
                  </Popconfirm>
                )
              }
            </>
          )}
        />
      </Table>
    </div>
  </>
}

export default Form.create()(PaymentLog)
